<div class="page-wrapper">
  <div class="list-toolbar">
    <div class="filter-box" *ngIf="orders && pageName === 'orders'">
      <div
        class="all-orders filter-btn"
        [class.active-filter]="activeStatusTab === 'all'"
        (click)="filterByStatus('all')"
        data-test-id="orders-filter-all"
      >
        All <span class="divider">.</span
        >{{
          ordersStats.open +
            ordersStats.onHold +
            ordersStats.canceled +
            ordersStats.closed
        }}
      </div>
      <div
        class="open-orders filter-btn"
        [class.active-filter]="activeStatusTab === 'open'"
        (click)="filterByStatus('open', orderStatus.Open)"
        data-test-id="orders-filter-open"
      >
        Open <span class="divider">.</span>{{ ordersStats.open }}
      </div>
      <!-- Shown only while orders are held. Kept while it is the active tab, so the
           filter the list is showing never loses its tab. -->
      <div
        class="on-hold-orders filter-btn"
        *ngIf="ordersStats.onHold > 0 || activeStatusTab === 'onHold'"
        [class.active-filter]="activeStatusTab === 'onHold'"
        (click)="filterByStatus('onHold', orderStatus.OnHold)"
        data-test-id="orders-filter-on-hold"
      >
        On Hold <span class="divider">.</span>{{ ordersStats.onHold }}
      </div>
      <div
        class="canceled-orders filter-btn"
        [class.active-filter]="activeStatusTab === 'canceled'"
        (click)="filterByStatus('canceled', orderStatus.Canceled)"
        data-test-id="orders-filter-canceled"
      >
        Canceled <span class="divider">.</span>{{ ordersStats.canceled }}
      </div>
      <div
        class="closed-orders filter-btn"
        [class.active-filter]="activeStatusTab === 'closed'"
        (click)="filterByStatus('closed', orderStatus.Closed)"
        data-test-id="orders-filter-closed"
      >
        Closed <span class="divider">.</span>{{ ordersStats.closed }}
      </div>
    </div>

    <div class="search-box">
      <div
        class="form-control"
        [ngClass]="{
          'orders-control': pageName === 'orders',
          'reports-control': pageName === 'reports'
        }"
      >
        <div class="icon">
          <img src="/assets/img/icons/search.svg" alt="search" />
        </div>
        <input
          type="text"
          placeholder="Search orders…"
          (input)="searchOrder()"
          [(ngModel)]="searchString"
          data-test-id="orders-search"
        />
      </div>
      <button
        mat-stroked-button
        class="filter-btn"
        (click)="toggleFilterOptions()"
        data-test-id="orders-open-filters"
      >
        <mat-icon>filter_list</mat-icon>
        <span>Filters</span>
      </button>
      <button
        mat-button
        class="excel-btn"
        (click)="exportToExcel()"
        *ngIf="pageName === 'reports'"
        data-test-id="orders-export-excel"
      >
        Export to Excel
      </button>
    </div>
  </div>

  <div class="table-box">
    <table
      mat-table
      [dataSource]="dataSource"
      class="data-table orders-table orders-grid"
      id="orders-table"
      data-test-id="orders-table"
    >
      <ng-container
        *ngFor="let column of tableColumnsObj"
        [matColumnDef]="column.columnDef"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ 'sortable-header': !column.isCustom }"
          (click)="
            sortOrders(
              column.filterKey,
              column.isCustom,
              column.type,
              column.fieldId
            )
          "
        >
          <div
            class="table-header-wrapper"
            *ngIf="!column.isCustom"
            [class.sorted]="selectedSort.field === column.filterKey"
          >
            {{ column.header }}
            <div
              class="sort-controls"
              *ngIf="selectedSort.field === column.filterKey"
            >
              <mat-icon *ngIf="selectedSort.mode !== 'desc'"
                >arrow_drop_up</mat-icon
              >
              <mat-icon *ngIf="selectedSort.mode !== 'asc'"
                >arrow_drop_down</mat-icon
              >
            </div>
            <div
              class="sort-controls"
              *ngIf="selectedSort.field !== column.filterKey"
            >
              <mat-icon>arrow_drop_up</mat-icon>
              <mat-icon>arrow_drop_down</mat-icon>
            </div>
          </div>
          <div class="table-header-wrapper" *ngIf="column.isCustom">
            {{ column.header }}
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let order"
          [attr.data-test-id]="'orders-cell-' + column.columnDef"
          [ngClass]="{
            'po-number': column.columnDef === 'poNumber',
            'date-info':
              column.columnDef === 'createdOn' ||
              column.columnDef === 'lastModifiedOn',
            'consignee-info': column.columnDef === 'consigneeName',
            'order-stage': column.columnDef === 'stage'
          }"
        >
          <!--
            Real <a href> stretched over the cell so the row can be opened with
            middle-click / ctrl+click / "Open link in new tab". Only the first
            column is a tab stop; the rest are duplicates of the same target.
          -->
          <a
            class="row-link"
            [routerLink]="['../orders', order.id]"
            [attr.tabindex]="column.columnDef === displayedColumns[0] ? 0 : -1"
            [attr.aria-hidden]="
              column.columnDef === displayedColumns[0] ? null : true
            "
            [attr.aria-label]="
              column.columnDef === displayedColumns[0]
                ? 'Open order ' + order.poNumber
                : null
            "
          ></a>

          <div class="num-box" *ngIf="column.columnDef === 'poNumber'">
            <span class="new-tag" *ngIf="order.isNew" aria-label="New order"
              >NEW</span
            >
            {{ column.cell(order) }}
          </div>

          <div class="num-box" *ngIf="column.columnDef === 'orderNumber'">
            {{ column.cell(order) !== "N/A" ? column.cell(order) : "-" }}
          </div>

          <div *ngIf="column.columnDef === 'healthCertificateNumber'">
            {{ column.cell(order) !== "N/A" ? column.cell(order) : "-" }}
          </div>

          <div
            class="status-label"
            *ngIf="column.columnDef === 'status'"
            [ngClass]="{
              'open-label': order.status === orderStatus.Open,
              'on-hold-label': order.status === orderStatus.OnHold,
              'closed-label': order.status === orderStatus.Closed,
              'canceled-label': order.status === orderStatus.Canceled
            }"
          >
            <span class="status-mark"></span>
            <span class="status-text">{{ statusLabel(order.status) }}</span>
          </div>

          <div
            class="ts-cell"
            *ngIf="
              column.columnDef === 'createdOn' ||
              column.columnDef === 'lastModifiedOn'
            "
          >
            <span class="ts-date">{{
              column.cell(order) | date : "MM/dd/yyyy"
            }}</span>
            <span class="ts-time">{{
              column.cell(order) | date : "hh:mm a"
            }}</span>
          </div>

          <div *ngIf="column.columnDef === 'stage'" class="stage-table-cell">
            <div class="stage-hidden-title" style="display: none">
              <span *ngIf="order.stage === orderStage.Stage1"
                >Stage 1 &nbsp;</span
              >
              <span *ngIf="order.stage === orderStage.Stage2A"
                >Stage 2A &nbsp;</span
              >
              <span *ngIf="order.stage === orderStage.Stage2B"
                >Stage 2B &nbsp;</span
              >
              <span *ngIf="order.stage === orderStage.Stage3"
                >Stage 3 &nbsp;</span
              >
              <span *ngIf="order.stage === orderStage.Stage4"
                >Stage 4 &nbsp;</span
              >
            </div>
            <div class="stage-title">
              <ng-container
                *ngIf="
                  order.status === orderStatus.Closed ||
                  order.stage > orderStage.Stage3
                "
              >
                <span *ngIf="order.stage === orderStage.Stage1">Customer</span>
                <span
                  *ngIf="
                    order.stage === orderStage.Stage2A ||
                    order.stage === orderStage.Stage3
                  "
                  >CM Inventory</span
                >
                <span
                  *ngIf="
                    order.stage === orderStage.Stage2B ||
                    order.stage === orderStage.Stage4
                  "
                  >Cold Storage</span
                >
              </ng-container>
            </div>
            <div class="stage-state-box">
              <div class="stage-diagram">
                <div
                  class="diagram-cell"
                  [ngClass]="{
                    one:
                      order.status === orderStatus.Closed ||
                      order.stage > orderStage.Stage3 ||
                      order.stage1NotifiedOn
                  }"
                ></div>
                <div
                  class="diagram-cell"
                  [ngClass]="{
                    two:
                      order.status === orderStatus.Closed ||
                      order.stage > orderStage.Stage3 ||
                      order.stage2ANotifiedOn
                  }"
                ></div>
                <div
                  class="diagram-cell"
                  [ngClass]="{
                    three:
                      order.status === orderStatus.Closed ||
                      order.stage > orderStage.Stage3 ||
                      order.stage2BNotifiedOn
                  }"
                ></div>
                <div
                  class="diagram-cell"
                  [ngClass]="{
                    four:
                      order.status === orderStatus.Closed ||
                      order.stage > orderStage.Stage3
                  }"
                ></div>
                <div
                  class="diagram-cell"
                  [ngClass]="{
                    five: order.status === orderStatus.Closed
                  }"
                ></div>
              </div>
              <div
                class="done-mark"
                *ngIf="order.status === orderStatus.Closed"
              >
                <mat-icon>check_circle</mat-icon>
              </div>
            </div>
          </div>

          <div
            class="customer-name"
            *ngIf="column.columnDef === 'customerName'"
            (click)="goToCustomer($event, order.customerId)"
          >
            {{ column.cell(order) | nullTransform }}
          </div>

          <div *ngIf="column.columnDef === 'countryId'">
            {{ column.cell_id(order) }}
          </div>

          <div
            *ngIf="
              column.columnDef === 'consigneeName' ||
              column.columnDef === 'coldStorageName'
            "
          >
            {{ column.cell(order) | nullTransform }}
          </div>

          <div *ngIf="column.isCustom">
            <span *ngIf="column.type === customFieldType.DateTime">{{
              column.cell_alt(order) | date : "MM/dd/yyyy hh:mm a"
            }}</span>
            <span *ngIf="column.type !== customFieldType.DateTime">{{
              column.cell_alt(order)
            }}</span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <!-- navigation lives on the per-cell .row-link anchors, not on the row -->
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="order-data-row"
        [attr.data-test-id]="'orders-row-' + row.id"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRow data-test-id="orders-no-data">
        <td class="mat-cell no-data-cell" colspan="1">
          No data matching the filter
        </td>
      </tr>
    </table>
  </div>
  <app-paginator
    [records]="paginationData"
    (pageSettings)="getPageSettings($event)"
  ></app-paginator>
</div>

<div
  class="filter-modal modal-el"
  (click)="hideModal($event)"
  *ngIf="showFilterModal"
>
  <div class="filters-box modal-info-box" data-test-id="orders-filters-modal">
    <div class="filter-title">Manage Columns</div>
    <div class="filter-options">
      <div class="columns-options">
        <div class="col-title">
          <span>Select columns</span>
          <span class="reorder-hint">(Drag to reorder)</span>
        </div>
        <div class="col-list">
          <ul id="columns-list">
            <li
              *ngFor="let col of reorderedColumns; let i = index"
              draggable="true"
              (dragstart)="dragItem($event, col)"
              (dragenter)="disableDefaultBehavior($event)"
              (dragover)="disableDefaultBehavior($event)"
              (drop)="dropItem($event)"
              (click)="selectLine(col)"
              [id]="col"
              [attr.data-test-id]="'orders-filter-col-' + col"
              class="li-line"
              [ngClass]="{ 'hidden-filter': hideCustomField(col) }"
            >
              <div class="li" (click)="selectCol(col)">
                <div class="drag-icon">
                  <mat-icon>menu</mat-icon>
                </div>
                <div class="item-title">
                  {{
                    col === "poNumber"
                      ? "P. O. NO."
                      : col === "coldStorageName"
                      ? "Cold Storage"
                      : col === "customerName"
                      ? "Customer"
                      : col === "consigneeName"
                      ? "Consignee"
                      : col === "createdOn"
                      ? "Created"
                      : col === "lastModifiedOn"
                      ? "Modified"
                      : col === "countryId"
                      ? "Destination country"
                      : col
                  }}
                </div>
                <div class="visibility-checkbox">
                  <mat-checkbox
                    class="remember"
                    [(ngModel)]="columnsStates[i]"
                    (change)="showHideColumn(i, col, $event)"
                  ></mat-checkbox>
                </div>
              </div>
              <div
                class="funnel-icon"
                [ngClass]="{ 'funnel-icon-gray': !isSettedFilter(col) }"
              >
                <img
                  *ngIf="!isSettedFilter(col)"
                  src="/assets/img/icons/funnel.svg"
                  alt="filter"
                />
                <img
                  *ngIf="isSettedFilter(col)"
                  src="/assets/img/icons/funnel_active.svg"
                  alt="filter"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="reset-box" (click)="resetFilters()">Reset</div>
      </div>
      <div class="orders-options">
        <div
          class="field-form"
          *ngFor="let fieldFilter of allFieldFilters; let i = index"
        >
          <div class="f-form" *ngIf="selectedCol === fieldFilter.name">
            <div (click)="removeValue(fieldFilter)" class="clear">Clear</div>
            <div class="col-title">
              {{
                fieldFilter.name === "countryId"
                  ? "Destination country"
                  : formatName(fieldFilter.name)
              }}
            </div>
            <div class="form-control" *ngIf="fieldFilter.type === 'enum'">
              <div *ngIf="fieldFilter.name === 'status'">
                <mat-form-field appearance="outline">
                  <mat-select
                    disableRipple
                    hideSingleSelectionIndicator
                    [disabled]="!fieldFilter.isShow"
                    [(ngModel)]="fieldFilter.value"
                    data-test-id="orders-filter-status-select"
                  >
                    <mat-option
                      *ngFor="let option of statusEnumValues"
                      [value]="option.value"
                      [attr.data-test-id]="'orders-filter-status-option-' + option.value"
                      >{{ option.name }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matSuffix class="select-icon-replacement"
                    >expand_more</mat-icon
                  >
                </mat-form-field>
              </div>
              <div *ngIf="fieldFilter.name === 'stage'">
                <mat-form-field appearance="outline">
                  <mat-select
                    disableRipple
                    hideSingleSelectionIndicator
                    [disabled]="!fieldFilter.isShow"
                    [(ngModel)]="fieldFilter.value"
                    data-test-id="orders-filter-stage-select"
                  >
                    <mat-option
                      *ngFor="let option of stageEnumValues"
                      [value]="option.value"
                      [attr.data-test-id]="'orders-filter-stage-option-' + option.value"
                      [disabled]="
                        option.value === orderStage.Stage1 ||
                        option.value === orderStage.Stage2A ||
                        option.value === orderStage.Stage2B
                      "
                      >{{ option.name }}</mat-option
                    >
                  </mat-select>
                  <mat-icon matSuffix class="select-icon-replacement"
                    >expand_more</mat-icon
                  >
                </mat-form-field>
              </div>
            </div>
            <div
              class="form-control"
              *ngIf="
                (fieldFilter.type === 'text' || fieldFilter.type === 'list') &&
                fieldFilter.name !== 'countryId'
              "
            >
              <input
                type="text"
                placeholder="Value"
                [disabled]="!fieldFilter.isShow"
                [(ngModel)]="fieldFilter.value"
                data-test-id="orders-filter-value"
              />
            </div>
            <div class="form-control" *ngIf="fieldFilter.name === 'countryId'">
              <mat-form-field appearance="outline">
                <mat-select
                  disableRipple
                  hideSingleSelectionIndicator
                  [disabled]="!fieldFilter.isShow"
                  [(ngModel)]="fieldFilter.value"
                  data-test-id="orders-filter-country-select"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      placeholderLabel="Search..."
                      [formControl]="searchCountries"
                      noEntriesFoundLabel="No countries found"
                      [clearSearchInput]="false"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let country of countries"
                    [value]="country.id"
                    [attr.data-test-id]="'orders-filter-country-option-' + country.id"
                    >{{ country.name }}</mat-option
                  >
                </mat-select>
                <mat-icon matSuffix class="select-icon-replacement"
                  >expand_more</mat-icon
                >
              </mat-form-field>
            </div>
            <div class="form-control" *ngIf="fieldFilter.type === 'number'">
              <input
                type="number"
                placeholder="Value"
                [disabled]="!fieldFilter.isShow"
                [(ngModel)]="fieldFilter.value"
                data-test-id="orders-filter-value"
              />
            </div>
            <div class="form-control" *ngIf="fieldFilter.type === 'date'">
              <mat-form-field appearance="outline">
                <input
                  matInput
                  [disabled]="!fieldFilter.isShow"
                  [matDatepicker]="picker"
                  [(ngModel)]="fieldFilter.value"
                  class="date-input"
                  (click)="picker.open()"
                  data-test-id="orders-filter-value"
                />
                <mat-datepicker-toggle matIconSuffix [for]="picker">
                  <mat-icon matDatepickerToggleIcon
                    >keyboard_arrow_down</mat-icon
                  >
                </mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="radio-options">
              <mat-radio-group
                [disabled]="!fieldFilter.isShow"
                [(ngModel)]="fieldFilter.operator"
                data-test-id="orders-filter-operators"
              >
                <mat-radio-button value="Equals">is</mat-radio-button>
                <mat-radio-button value="!Equals">is not</mat-radio-button>
                <mat-radio-button
                  value="Contains"
                  *ngIf="
                    fieldFilter.type !== 'number' &&
                    fieldFilter.type !== 'date' &&
                    fieldFilter.type !== 'enum' &&
                    fieldFilter.name !== 'countryId'
                  "
                  >contains</mat-radio-button
                >
                <mat-radio-button
                  value="GreaterThan"
                  *ngIf="fieldFilter.type === 'number'"
                  >greater than</mat-radio-button
                >
                <mat-radio-button
                  value="GreaterThanOrEqual"
                  *ngIf="fieldFilter.type === 'number'"
                  >greater than or equal</mat-radio-button
                >
                <mat-radio-button
                  value="LessThan"
                  *ngIf="fieldFilter.type === 'number'"
                  >less than</mat-radio-button
                >
                <mat-radio-button
                  value="LessThanOrEqual"
                  *ngIf="fieldFilter.type === 'number'"
                  >less than or equal</mat-radio-button
                >
                <mat-radio-button
                  value="Any"
                  *ngIf="
                    (fieldFilter.type === 'text' ||
                      fieldFilter.type === 'number') &&
                    fieldFilter.name !== 'countryId'
                  "
                  >has any value</mat-radio-button
                >
              </mat-radio-group>
            </div>
          </div>
        </div>
        <div
          class="reset-multi-filters"
          (click)="resetMultiFilters()"
          data-test-id="orders-filter-reset"
        >
          Reset Filters
        </div>
      </div>
    </div>
    <div class="filter-actions form-actions">
      <button
        mat-stroked-button
        class="cancel-btn"
        (click)="cancelFiltering(); toggleFilterOptions()"
        data-test-id="orders-filter-cancel"
      >
        Cancel
      </button>
      <button
        mat-button
        class="action-btn"
        (click)="
          isApplyFilters = true;
          applyMultiFilters();
          applyFilters();
          toggleFilterOptions()
        "
        data-test-id="orders-filter-submit"
      >
        Submit Filters
      </button>
    </div>
  </div>
</div>

<div class="modal-el export-spinner" #exportModal></div>
